import { render, staticRenderFns } from "./Contenedor.vue?vue&type=template&id=0644900a&scoped=true"
import script from "./Contenedor.vue?vue&type=script&lang=js"
export * from "./Contenedor.vue?vue&type=script&lang=js"
import style0 from "./Contenedor.vue?vue&type=style&index=0&id=0644900a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0644900a",
  null
  
)

export default component.exports